module.exports = __webpack_public_path__ + "img/logo-icon-app.96a70833.png";